import { FC, PropsWithChildren } from 'react';

interface DrawerBodyProps {
  className?: string;
}

export const DrawerBody: FC<PropsWithChildren<DrawerBodyProps>> = ({
  children,
  className
}) => {
  return (
    <div data-testid="drawer-body" className={className}>
      {children}
    </div>
  );
};
